import { EMAIL_REGEX } from './../../../shared/regular-expressions/regex';
import {
  TelecomAddComponent, getTelecomFormGroup,
} from '../../../widgets/entry-components/modal/components/telecom-add/telecom-add.component';
import { ModalService } from '../../../widgets/entry-components/modal/services/modal.service';
import { Component } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { NameComponent, getNameFormGroup } from '../../../widgets/entry-components/modal/components/name/name.component';
import { AddressComponent, getAddressFormGroup } from '../../../widgets/entry-components/modal/components/address/address.component';
import { TranslatePipe } from '../../../shared/translate/pipes/translate.pipe';
import { IPractitioner } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddWmodalComponent } from '../../../shared/abstracts/add/abstract-add-wmodal/abstract-add-wmodal.component';
import { AssociativeArray } from '../../../user/login/shared/ass-array.model';
import { GENDER_LIST } from '../../../widgets/entry-components/modal/components/gender/gender.component';

export function getPractitionerForm() {
  return new FormGroup({
    id: new FormControl(),
    extension: new FormArray([
      new FormGroup({
        url: new FormControl(),
        valueString: new FormControl('')
      })
    ]),
    identifier: new FormArray([new FormGroup({
      value: new FormControl('', [Validators.required, Validators.pattern(EMAIL_REGEX)])
      /*  Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)]) */
    })]),
    active: new FormControl(true),
    name: new FormArray([], Validators.required),
    gender: new FormControl('OTHER'),
    telecom: new FormArray([]),
    address: new FormArray([])
  });
}

@Component({
  selector: 'inc-practitioner-add',
  templateUrl: './practitioner-add.component.html',
  styleUrls: ['./practitioner-add.component.scss'],
})
export class PractitionerAddComponent extends AbstractAddWmodalComponent<IPractitioner> {
  genderList = GENDER_LIST;

  modalComponents: AssociativeArray = {
    name: () => NameComponent,
    address: () => AddressComponent,
    telecom: () => TelecomAddComponent
  };

  constructor(
    modalService: ModalService, actionSheetController: ActionSheetController,
    translatePipe: TranslatePipe) {
    super(modalService, actionSheetController, translatePipe);
  }

  resetForm(): FormGroup {
    return getPractitionerForm();
  }

  save(practitionerData: IPractitioner) {
    this.inData ? this.callUpdate.emit(practitionerData) : this.callSave.emit(
      { data: practitionerData } as any);
  }

  async addDetails() {
    const actionSheet = await this.actionSheetController.create({
      header: this.translatePipe.transform('ADDOTHERDATAS'),
      buttons: [
        {
          text: this.translatePipe.transform('ADDRESS'),
          icon: 'business',
          handler: () => {
            this.openModal('address');
          }
        }, {
          text: this.translatePipe.transform('AVAILABILITY'),
          icon: 'call',
          handler: () => {
            this.openModal('telecom');
          }
        },
        {
          text: this.translatePipe.transform('BACK'),
          icon: 'close',
          role: 'cancel'
        }]
    });
    await actionSheet.present();
  }
}
